/**
 * ReviewBadge — compact chip shown on question cards / list rows to
 * indicate a "Needs Review" flag. Renders nothing when the question
 * isn't flagged.
 *
 * Props:
 *   - question: doc with needs_review + review_category_id + review_remarks
 *   - category: optional resolved {name,color} from useReviewConfig().getCategory()
 *   - compact: bool — use tiny variant for dense lists
 */
import React from 'react';
import { Badge } from '../ui/badge';
import { ClipboardPen } from 'lucide-react';

const ReviewBadge = ({ question, category, compact = false, dataTestId }) => {
  if (!question?.needs_review) return null;

  const label = category?.name || 'Uncategorized';
  const color = category?.color || '#f59e0b';

  return (
    <Badge
      variant="outline"
      className={
        compact
          ? 'text-[9px] py-0 px-1.5 h-4 border-amber-300 bg-amber-50 text-amber-800 gap-0.5 leading-none'
          : 'text-[10px] py-0.5 px-2 h-5 border-amber-300 bg-amber-50 text-amber-800 gap-1'
      }
      title={question?.review_remarks ? `Remarks: ${question.review_remarks}` : 'Needs Review'}
      data-testid={dataTestId || 'review-badge'}
    >
      <ClipboardPen className={compact ? 'w-2.5 h-2.5' : 'w-3 h-3'} style={{ color }} />
      <span>Review</span>
      {label && label !== 'Uncategorized' && (
        <span className="opacity-75">· {label}</span>
      )}
    </Badge>
  );
};

export default ReviewBadge;
